import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
  SalesPlanService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "agent-yearly-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./PartySeasonalReport.html",
})
export class PartySeasonalReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("params") params: any;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  exceldata: any;
  gradeCtrl: FormControl = new FormControl();
  gradeList = ["A", "B", "C", "D"];
  filter = {
    season_id: 0,
    grade: "",
    fin_id: 3,
  };
  page = {
    limit: 2500,
    count: 0,
    offset: 0,
    orderBy: "agent",
    orderDir: "asc",
  };
  finyearList: any[];
  gridOptions: any;
  agentCtrl: FormControl = new FormControl();
  user: any;
  agentVisible: boolean = false;
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finyear") finyear;

  seasonCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    name: "",
    grade: "",
    agent_id: 0,
    //company_id: 0
  };
  agentList$ = [];
  agentList = [];
  companyInfo: any = [];
  constructor(
    private salesplanservice: SalesPlanService,
    private excelService: ExcelService,
    private combo: Combo2Service,
    public store: Store<fromRootStore.State>,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  printConfig: any = {
    title: "Party Seasonal report",
    columns: [],
    rows: [],
  };

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  ngOnInit(): void {
    //     this.loadSeasonList();
    this.LoadFinYearList();
    this.columns = [];
    /*  this.columns = [
              { 
                  "name": "S.No", 
                  "width": "100px",
                   "maxWidth": "100px", 
                  //"cellTemplate": this.snoTemplate,
                   "minWidth": "100px",
                    "prop": "sno",
                    "type":'sno' },
  
              { "name": "Name", "width": 300, "maxWidth": 300, "minWidth": 300, "prop": "party_name" },
  
              { 
                  "name": "Summer & Ramzan Target", 
                  "width": "100px", 
                  "cellClass": "txtRight", 
                  "maxWidth": "100px",
                   "minWidth": "100px",
                    "summary": "sum", 
                  "headerClass": "season_3_header",
                    "prop": "season_3_target"
                   },
              
              { "name": "Summer & Ramzan Qty",
               "width": "100px", "summary": "sum",
                "maxWidth": "100px", 
                  "headerClass": "season_3_header",
                "cellClass": "txtRight", "minWidth": "100px", "prop": 'season_3_qty' },
                
                { "name": "Summer & Ramzan Diff",
                    "headerClass": "season_3_header",
                "summary": "sum", "maxWidth": "100px", "cellClass": "txtRight", "minWidth": "100px", "width": "100px", "prop": "season_3_diff" }, 
                
                { "name": "Deepavali Target", "width": "100px", "cellClass": "txtRight",
                    "headerClass": "season_4_header",
                "maxWidth": "100px", "minWidth": "100px", "summary": "sum", "prop": "season_4_target" }, 
              { "headerClass": "season_4_header", "name": "Deepavali Qty", "width": "100px", "summary": "sum", "maxWidth": "100px", "cellClass": "txtRight", "minWidth": "100px", "prop": "season_4_qty" }, { "headerClass": "season_4_header", "name": "Deepavali Diff", "summary": "sum", "maxWidth": "100px", "cellClass": "txtRight", "minWidth": "100px", "width": "100px", "prop": "season_4_diff" }, { "name": "Aadi Target", "width": "100px", "cellClass": "txtRight", "maxWidth": '100px', 'minWidth': '100px', 'summary': 'sum', 'prop': 'season_7_target', "headerClass": "season_7_header" }, { 'name': 'Aadi Qty', 'width': '100px', 'summary': 'sum', 'maxWidth': '100px', 'cellClass': 'txtRight', 'minWidth': '100px', 'prop': 'season_7_qty', "headerClass": "season_7_header" }, { 'name': 'Aadi Diff', 'summary': 'sum', 'maxWidth': '100px', 'cellClass': 'txtRight', 'minWidth': '100px', 'width': '100px', 'prop': 'season_7_diff', "headerClass": "season_7_header" }, { 'name': 'Pongal Target', 'width': '100px', 'cellClass': 'txtRight', 'maxWidth': '100px', 'minWidth': '100px', 'summary': 'sum', 'prop': 'season_8_target', "headerClass": "season_8_header" }, { 'name': 'Pongal Qty', 'width': '100px', 'summary': 'sum', 'maxWidth': '100px', 'cellClass': 'txtRight', 'minWidth': '100px', 'prop': 'season_8_qty', "headerClass": "season_8_header" }, { 'name': 'Pongal Diff', 'summary': 'sum', 'maxWidth': '100px', 'cellClass': 'txtRight', 'minWidth': '100px', 'width': '100px', 'prop': 'season_8_diff', "headerClass": "season_8_header" }, { 'name': 'Wedding Target', 'width': '100px', 'cellClass': 'txtRight', 'maxWidth': '100px', 'minWidth': '100px', 'summary': 'sum', 'prop': 'season_9_target', "headerClass": "season_9_header" }, { 'name': 'Wedding Qty', 'width': '100px', 'summary': 'sum', 'maxWidth': '100px', 'cellClass': 'txtRight', 'minWidth': '100px', 'prop': 'season_9_qty', "headerClass": "season_9_header" }, { 'name': 'Wedding Diff', 'summary': 'sum', 'maxWidth': '100px', 'cellClass': 'txtRight', 'minWidth': '100px', 'width': '100px', 'prop': 'season_9_diff', "headerClass": "season_9_header" }];
          this.toggleCol = Object.assign({}, this.columns);*/
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    // this.pageCallback({ offset: 0 });
    this.checkuser();
  }

  checkuser() {
    let that = this;

    if (this.user.params && !this.user.params.agent_id) {
      that.agentVisible = true;
    }
  }

  hotkeys(event) {
    if (this.active) {
    }
  }
  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }
  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getAgentSeasonalReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getAgentSeasonalReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getAgentSeasonalReport();
  }

  LoadAgentList() {
    let that = this;
    this.salesplanservice.getAgentList({}).then((res: any) => {
      that.agentList = res.data;
      if (that.params && that.params.data) {
        let agent_id = that.params.data.agent_id;
        that.filterData.agent_id = agent_id;
        that.agentCtrl.setValue(agent_id + "");
        that.getAgentSeasonalReport();
      } else {
      }
      that.applyFilter();
    });
  }

  getAgentSeasonalReport(): void {
    let params: any;
    if (this.user.username == "admin") {
      params = {
        start: `${this.page.offset * (this.page.limit + 1)}`,
        limit: `${this.page.limit}`,
        page: "1",
        // name:this.filterData.name,
        orderColumn: `${this.page.orderBy}`,
        orderDir: `${this.page.orderDir}`,
        grade: this.filterData.grade,
        agent_id: this.filterData.agent_id,
        filter: JSON.stringify(this.filter),
        season_id: this.filter.season_id,
        fin_id: this.filter.fin_id,
        // tabTitle: this.title
      };
    } else {
      params = {
        start: `${this.page.offset * (this.page.limit + 1)}`,
        limit: `${this.page.limit}`,
        page: "1",
        // name:this.filterData.name,
        orderColumn: `${this.page.orderBy}`,
        orderDir: `${this.page.orderDir}`,
        grade: this.filterData.grade,
        agent_id: this.user.params.agent_id,
        filter: JSON.stringify(this.filter),
        season_id: this.filter.season_id,
        fin_id: this.filter.fin_id,
        // tabTitle: this.title
      };
    }
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getPartySeasonal(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        // that.columns = res.columns;
        //  that.columns[0].cellTemplate = that.snoTemplate;
        //  that.page.count = res.data.length;
        //that.dataList = res.data;

        that.gridOptions = {
          columns: res.columns,
          data: res.data,
          loading: false,
        };

        that.refreshData();
        that.exceldata = that.getData(res.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        that.printConfig = {
          title: "Party Seasonal report",
          columns: that.gridOptions.columns,
          rows: that.gridOptions.data,
        };
        //  that.columns = res.columns;
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.filterData = {
      name: "",
      grade: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    // this.filterExpand = false;
    this.filterPanel.close();
    this.getAgentSeasonalReport();
  }

  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Agent") {
      list = this.agentList;
    }

    if (id && list.length > 0) {
      this.filterData.agent_id = id;
      const fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      const fitem = _.find(list, { fin_id: id });
      this.filter.fin_id = id;
      return fitem["finyear"];
    }
    return "";
  }
  loadSeasonList() {
    const that = this;
    that.reportService.getNewSeasonList(this.filter).then(function (res) {
      that.seasonList = res;
    });
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      const fin = res.data[0];
      that.filterData.fin_id = fin["fin_id"];
      that.filter.fin_id = fin["fin_id"];
      that.finyearCtrl.setValue(fin["fin_id"]);
      that.LoadAgentList();
    });
  }

  refreshData() {
    const columns = this.columns,
      data = this.gridOptions.data,
      row = this.getSummaryRow(data, columns);
    if (data.length > 0) {
      data.push(row);
      this.page.count = data.length;
    }
  }
  onRowSelected($event) {
    console.log("Row Double Clicked");
    console.log($event);
  }
  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            const dat = data[j];
            total += isNaN(dat[col.prop]) ? 0 : dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/PartySeasonalReport/PartySeasonalReport.ts